import { useQuery } from "@tanstack/react-query";

export type Branding = {
  productName: string;
  shortName: string;
  tagline: string;
  poweredBy: string;
};

export const DEFAULT_BRANDING: Branding = {
  productName: "Maisters CampusAssist™ - University",
  shortName: "CampusAssist",
  tagline: "AI Chatbot Platform",
  poweredBy: "App Maisters Inc.",
};

export function useBranding(): Branding {
  const { data } = useQuery<Partial<Branding> | null>({
    queryKey: ["/api/branding"],
    staleTime: 5 * 60 * 1000,
  });
  return {
    productName: data?.productName?.trim() || DEFAULT_BRANDING.productName,
    shortName: data?.shortName?.trim() || DEFAULT_BRANDING.shortName,
    tagline: data?.tagline?.trim() || DEFAULT_BRANDING.tagline,
    poweredBy: data?.poweredBy?.trim() || DEFAULT_BRANDING.poweredBy,
  };
}
